<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <div v-if="data && data.order" class="topRect">
      <van-row>
        <van-col span="8"> <img :src="productInfo.bigLogo"></van-col>
        <van-col span="16" class="rigth">
          <span :style="'font-size:0.8em;color:'+GetColorMainBack()" @click="onProduct()">查看产品详情</span>
        </van-col>
      </van-row>
      <div class="ProductTitle">{{ data.order.productName }}</div>
    </div>
    <div v-if="data && data.order" class="baseRect">
      <div class="rectTitle">订单状态</div>
      <van-steps direction="vertical" :active="0" :active-color="GetColorMainBack()">
        <van-step v-if="data.order.cancelTime">
          <van-row>
            <van-col span="12">{{ formatDate(data.order.cancelTime,'yyyy/MM/dd hh:mm:ss',true) }}</van-col>
            <van-col span="12">最后一次退保</van-col>
          </van-row>
        </van-step>
        <van-step v-if="data.order.producePolicyTime">
          <van-row>
            <van-col span="12">{{ formatDate(data.order.producePolicyTime,'yyyy/MM/dd hh:mm:ss',true) }}</van-col>
            <van-col span="12">总电子保单生成</van-col>
          </van-row>
        </van-step>
        <van-step v-if="data.order.issueTime">
          <van-row>
            <van-col span="12">{{ formatDate(data.order.issueTime,'yyyy/MM/dd hh:mm:ss',true) }}</van-col>
            <van-col span="12">承保出单</van-col>
          </van-row>
        </van-step>
        <van-step v-if="data.order.payTime">
          <van-row>
            <van-col span="12">{{ formatDate(data.order.payTime,'yyyy/MM/dd hh:mm:ss',true) }}</van-col>
            <van-col span="12">支付成功</van-col>
          </van-row>
        </van-step>
        <van-step>
          <van-row>
            <van-col span="12">{{ formatDate(data.order.createTime,'yyyy/MM/dd hh:mm:ss',true) }}</van-col>
            <van-col span="12">提交投保单</van-col>
          </van-row>
        </van-step>
      </van-steps>
    </div>
    <div v-if="orderInfo && orderInfo.applicant" class="baseRect">
      <div class="rectTitle">投保人信息</div>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">姓名:</van-col>
        <van-col span="16">{{ orderInfo.applicant.cName }}</van-col>
      </van-row>
      <van-row v-if="orderInfo.applicant.eName" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">英文名:</van-col>
        <van-col span="16">{{ orderInfo.applicant.eName }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">出生日期:</van-col>
        <van-col span="16">{{ orderInfo.applicant.birthday }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">证件类型:</van-col>
        <van-col span="16">{{ orderInfo.applicant.cardName }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">证件号码:</van-col>
        <van-col span="16">{{ orderInfo.applicant.cardNumber }}</van-col>
      </van-row>
      <van-row v-if="orderInfo.applicant.email" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">电子邮箱:</van-col>
        <van-col span="16">{{ orderInfo.applicant.email }}</van-col>
      </van-row>
      <van-row v-if="orderInfo.applicant.mobile" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">手机号码:</van-col>
        <van-col span="16">{{ orderInfo.applicant.mobile }}</van-col>
      </van-row>

    </div>
    <div v-if="orderInfo" class="baseRect">
      <div class="rectTitle">被保险人信息</div>
      <div v-for="(item,index) in orderInfo.insurants" :key="index" class="insurant">
        <div class="insurantTitle">被保险人({{ index+1 }})</div>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">我是被保险人的:</van-col>
          <van-col span="16">{{ item.relationName }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">姓名:</van-col>
          <van-col span="16">{{ item.cName }}</van-col>
        </van-row>
        <van-row v-if="item.eName" class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">英文名:</van-col>
          <van-col span="16">{{ item.eName }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">出生日期:</van-col>
          <van-col span="16">{{ item.birthday }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">证件类型:</van-col>
          <van-col span="16">{{ item.cardName }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">证件号码:</van-col>
          <van-col span="16">{{ item.cardNumber }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">性别:</van-col>
          <van-col span="16">{{ item.sex===1?'男':'女' }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">份数:</van-col>
          <van-col span="16">{{ item.buyAmount }}</van-col>
        </van-row>
        <van-row class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">价格:</van-col>
          <van-col span="16">CNY {{ ShowMoney(item.singlePrice*0.01) }}</van-col>
        </van-row>
        <van-row v-if="data.order.cancelCardIdList && data.order.cancelCardIdList.indexOf(item.cardNumber)>=0" class="body">
          <van-col span="8" :style="'color:'+GetColorMainBack()">状态:</van-col>
          <van-col span="16" :style="'color:'+GetColorMainBack()">已退保</van-col>
        </van-row>
      </div>
    </div>
    <div v-if="data && data.order" class="baseRect">
      <div class="rectTitle">受益人信息</div>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">受益人:</van-col>
        <van-col span="16">法定受益人</van-col>
      </van-row>
    </div>
    <div v-if="orderInfo&& orderInfo.other" class="baseRect">
      <div class="rectTitle">其他信息</div>
      <van-row v-if="orderInfo.other.fltNo" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">航班号:</van-col>
        <van-col span="16">{{ orderInfo.other.fltNo }}</van-col>
      </van-row>
      <van-row v-if="orderInfo.other.tripPurposeName" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">出行目的:</van-col>
        <van-col span="16">{{ orderInfo.other.tripPurposeName }}</van-col>
      </van-row>
      <van-row v-if="orderInfo.other.destination" class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">出行目的地:</van-col>
        <van-col span="16">{{ orderInfo.other.destination }}</van-col>
      </van-row>
    </div>
    <div v-if="orderInfo && data.order" class="baseRect">
      <div class="rectTitle">投保信息</div>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">总价:</van-col>
        <van-col span="16">CNY {{ ShowMoney(data.order.payAmount*0.01) }}
          <span v-if="data.order.payAmountNow!==data.order.payAmount" style="color:#999"> [已退{{ ShowMoney((data.order.payAmount-data.order.payAmountNow)*0.01) }}]</span>
        </van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">保障日期:</van-col>
        <van-col span="16">{{ orderInfo.deadline }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">保障期限:</van-col>
        <van-col span="16">{{ orderInfo.deadlineText }}</van-col>
      </van-row>
      <div class="insurant">
        <div class="insurantTitle">
          <van-row class="body">
            <van-col span="16">保障项目</van-col>
            <van-col span="8" class="rigth">保额/详情</van-col>
          </van-row>
        </div>
        <van-row v-for="(item,index) in orderInfo.projects" :key="index" class="body">
          <van-col span="16">{{ item.projectName }}</van-col>
          <van-col span="8" class="rigth">{{ item.insuredText }}</van-col>
        </van-row>
      </div>
    </div>
    <div v-if="data && data.order" class="baseRect">
      <div class="rectTitle">其他</div>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">保险公司:</van-col>
        <van-col span="16">{{ data.product.companyName }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">生效状态:</van-col>
        <van-col span="16">{{ GetEnumText('Em_EffectiveStatus',data.order.effectiveStatus) }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">出单状态:</van-col>
        <van-col span="16">{{ GetEnumText('Em_IssueStatus',data.order.issueStatus) }}</van-col>
      </van-row>
      <van-row class="body">
        <van-col span="8" :style="'color:'+GetColorMainBack()">支付状态:</van-col>
        <van-col span="16">{{ GetEnumText('Em_InsurancePayStatus',data.order.payStatus) }}</van-col>
      </van-row>
    </div>
    <div class="downEmpty" />
    <div v-if="data && data.order" class="downButton">
      <van-row v-if="data.order.payStatus ==='UnPay'">
        <van-col span="12"><van-button size="large" :color="GetColorSecondary()" @click="onProduct">再买一单</van-button></van-col>
        <van-col span="12"><van-button size="large" :color="GetColorMainBack()" @click="onPay">前往支付</van-button></van-col>
      </van-row>
      <van-row v-if="data.order.payStatus !=='UnPay'">
        <van-col span="12"><van-button size="large" :color="GetColorSecondary()" @click="onProduct">再买一单</van-button></van-col>
        <van-col span="12"><van-button size="large" :color="GetColorMainBack()" @click="onDownload">保单下载</van-button></van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Step, Steps } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { GetServiceUrlBase } from '@/utils/request'
import { getToken } from '@/utils/auth'

export default {
  components: {
    [Button.name]: Button,
    [Step.name]: Step,
    [Steps.name]: Steps,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '我的保险',
      backurl: '/insurance/myList',
      insuranceOrderId: undefined,
      loading: true,
      data: {},
      orderInfo: {},
      productInfo: {}
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.insuranceOrderId = this.$route.params.id
    var urlJump = getUrlKey('jumpurl')
    if (urlJump) {
      this.$router.push('/insurance/myInfo/' + this.insuranceOrderId)
      setTimeout(() => {
        window.location.href = decodeURIComponent(urlJump)
      }, 1)
    } else {
      this.init()
    }
  },
  methods: {
    UrlBase64,
    getToken,
    GetServiceUrlBase,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    MyNotify,
    init() {
      this.loading = true
      request({
        url: '/Insurance/GetUserInsuranceOrder',
        method: 'post',
        params: { id: this.insuranceOrderId }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.orderInfo = JSON.parse(response.data.order.body)
        this.productInfo = JSON.parse(response.data.product.body)
        response.data.order.body = undefined
        response.data.product.body = undefined
        console.log('orderInfo', this.orderInfo)
        console.log('productInfo', this.productInfo)
      })
    },
    onProduct() {
      this.$router.push('/insurance/info/' + this.data.product.insuranceProductId)
    },
    onPay() {
      if (this.data.order.payStatus !== 'UnPay') {
        MyNotify('info', '当前保单无法进行支付,请重新下单')
        return
      }
      window.location.href = this.data.order.cpsInsureUrl
    },
    onDownload() {
      var url = GetServiceUrlBase() + '/userAPI/Insurance/PolicyDownload?insuranceOrderId=' + this.insuranceOrderId +
      '&token=' + UrlBase64(getToken())
      window.location.href = url
    }
  }
}
</script>
<style scoped>
.topRect{
  background-color: #fff;
  padding: 1em;
}
.topRect img{
  width: 100%;
}
.topRect .ProductTitle{
  font-size: 0.9em;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.baseRect{
  margin-top: 1em;
  padding: 1em;
  background-color: #fff;
}
.baseRect .rectTitle{
  font-size: 0.9em;
  font-weight: 700;
  color: #999;
  line-height: 1.8em;
}
.baseRect .body{
  font-size: 0.9em;
  padding:0.25em 0;
}
.baseRect .insurant{
  border:1px solid #f5f5f5;
  margin-top: 0.5em;
  padding: 0.5em;
}
.baseRect .insurant .insurantTitle{
  font-size: 0.8em;
  background-color: #f5f5f5;
  padding: 0.5em;
}
.downEmpty{
  height: 3em;
}
.downButton{
  position:fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50px;
  border-top: 1px solid #f5f5f5;
  background-color: #fff;
}
</style>
